import { GetServerSidePropsContext } from "next"
import { destroyCookie, parseCookies } from "nookies"
import { JWT_SECRET, TOKEN_COOKIES } from "@const/shared"
import jwt from "jsonwebtoken"
import { HARISENIN_PUBLIC_LOGO } from "@constants/const/pictures"

export function tokenChecker() {
  const parsedCookies = parseCookies()
  const token = parsedCookies.HSTOKENID

  if (!token) {
    return null
  }

  jwt.verify(token, JWT_SECRET, (err) => {
    if (err) {
      destroyCookie(null, TOKEN_COOKIES)
      return null
    }
  })

  return token
}

export function serverTokenChecker(ctx: GetServerSidePropsContext): string | null {
  const parsedCookies = parseCookies(ctx)
  const token = parsedCookies.HSTOKENID

  if (!token) {
    return null
  }

  jwt.verify(token, JWT_SECRET, (err) => {
    if (err) {
      destroyCookie(ctx, TOKEN_COOKIES, {})
      return null
    }
  })

  return token
}

export const getHariseninURL = (path: string) => {
  const baseURL = process.env.HOME_URL || process.env.HARISENIN_HOME_URL
  return baseURL + path
}

export function checkCreditCardType(cc: string, getName?: boolean) {
  const cardNumber = cc.replace(/ /g, "")
  const amex = new RegExp("^3[47][0-9]{13}$")
  const visa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$")
  const cup1 = new RegExp("^62[0-9]{14}[0-9]*$")
  const cup2 = new RegExp("^81[0-9]{14}[0-9]*$")

  const mastercard = new RegExp("^5[1-5][0-9]{14}$")
  const mastercard2 = new RegExp("^2[2-7][0-9]{14}$")

  const disco1 = new RegExp("^6011[0-9]{12}[0-9]*$")
  const disco2 = new RegExp("^62[24568][0-9]{13}[0-9]*$")
  const disco3 = new RegExp("^6[45][0-9]{14}[0-9]*$")

  const diners = new RegExp("^3[0689][0-9]{12}[0-9]*$")
  const jcb = new RegExp("^35[0-9]{14}[0-9]*$")

  if (visa.test(cardNumber)) {
    return !getName ? `${HARISENIN_PUBLIC_LOGO}/logo_visa.png` : "VISA"
  }
  if (amex.test(cardNumber)) {
    return "AMEX"
  }
  if (mastercard.test(cardNumber) || mastercard2.test(cardNumber)) {
    return !getName ? `${HARISENIN_PUBLIC_LOGO}/logo_mastercard.png` : "MASTERCARD"
  }
  if (disco1.test(cardNumber) || disco2.test(cardNumber) || disco3.test(cardNumber)) {
    return "DISCOVER"
  }
  if (diners.test(cardNumber)) {
    return "DINERS"
  }
  if (jcb.test(cardNumber)) {
    return !getName ? `${HARISENIN_PUBLIC_LOGO}/logo_jcb.png` : "JCB"
  }
  if (cup1.test(cardNumber) || cup2.test(cardNumber)) {
    return "CHINA_UNION_PAY"
  }
  return ""
}
